import React, { useState, useEffect, useRef, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import {
  setConfirmZipcode,
  setValidZipcode,
  setZipcode,
  validateZipcode,
  setEmail,
  sendEmailDetails,
  addToCart,
  setStopNavigateToPlans,
} from "../../../pages/Mobility/ducks/MobilitySlice";
import { Body } from "@vds/typography";
import { Input } from "@vds/inputs";
import { useNavigate } from "react-router-dom";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Button, TextLink} from "@vds/buttons";
import {
  MarginSpacerL, MarginSpacerXL,
} from "../styleTag";
import { TitleLockup } from "@vds3/type-lockups";
import MapQStreetAddress from "pages/Checkout/components/ShippingInfo/components/MapQStreetAdress";
import { setSuspendFlow, setSuspendScenario } from "pages/Checkout/ducks/CheckoutSlice";
import {
  setAddress,
  setUnit,
  setTotalAvailableUnit,
  postLoopQualAddress,
} from "pages/Qualification/ducks/QualificationSlice";
import { setLocalCookie } from "../unifiedCart/utils";
import MapQUnit from "pages/Checkout/components/ShippingInfo/components/MapQUnit";
import { callAddressValidation } from "app/ducks/GlobalSlice";
import { getTaxesCharges } from "pages/Landing4G/ducks/4GSlice";
import * as SiteAnalytics from '../../../sitecatalyst';

const ZipcodeModalBody = styled(ModalBody)`
  padding: 0 0px 0;
  outline: none !important;
  height: auto;
`;
const ButtonWrapper = styled(Button)`
  @media screen and (max-width: 767px) {
    position: absolute;
    bottom: 2px;
    width: 97%;
    right: 3%;
  }
`;

const NewCustomerAddressModal = ({
  pageData = {},
  hideZipCode = false,
  isFrom4GLearn = false,
  onClose = () => {},
  setIsAddToCartClickedModal,
  setIsFirstDeviceClicked,
  ...props
}) => {
  const { t } = useTranslation(["app"]);
  const mobilityPageData = useSelector((state) => state.MobilityPage);
  const landing4gPageData = useSelector((state) => state.Landing4GPage);
  const globalPageData = useSelector((state) => state.GlobalData);
   const isfromAgentLinkPage = useSelector(state => state?.GlobalData?.fromAgentLinkDealsPage);
  const [newAddress, setNewAddress] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const availZip = pageData?.confirmZipcode != "" ? true : false;
  const [isZipcode, setIsZipcode] = useState(availZip);
  const [errors, setErrors] = useState({});
  const [isConfirm, setIsConfirm] = useState(false);
  const [zipCode, handleZipcode] = useState();
  const [isSmartphonelink,SetIsSmrtphclicked] = useState(false);
  const [hidZipCode, setHidZipCode] = useState(hideZipCode);
  const [unitsAvailable, setUnitsAvailable] = useState(null);
  const zipRef = useRef(mobilityPageData?.zipCode);
  const confirmRef = useRef(isConfirm);
  const [email, handleEmail] = useState("");
  const [isValidDAASzip,SetIsValidDAASzip]  = useState(false);
  const isEmailEnable = t("app.common.isEmailEnable", { ns: "app" });
  const showAddress2 = t("app.addressCodePopup.showAddress2", { ns: "app" });
  
  const lqPageData = useSelector((state) => state.LQPage);
  // const aemContent = t("4G-5G", { ns: "4G-5G", returnObjects: true });
  const [errorMessages, setErrorMessages] = useState({});
  // const [contentObj, setContentObj] = useState(aemContent.loopQual.landing);
  const [units, setUnits] = useState({});
  const isValidDAASZipcode = useSelector(
    (state) => state.MobilityPage?.validZipcode
  );
  const isZipcodeValidationSuccess = useSelector(
    (state) => state.MobilityPage?.zipCodeValidationSuccess
  );
  const isUnitFieldAvailable = lqPageData?.totalAvailableUnit?.length > 0 ? '' : 'none';
  const unifiedCartParams = useSelector(
    (state) => state.CheckoutPage?.unifiedCartParams
  );

  const address = lqPageData?.address;
  const zip = lqPageData?.address?.place?.properties?.postalCode?.split("-");

  const isMobile = useMediaQuery({
    query: "(max-width: 725px)",
  });

  // const handleKeyDown = (event) => {
  //   if (event?.code === "Enter") {
  //     confirmClicked(pageData?.zipCode);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeyDown);

  //   // populate default zipcode if none is present from BE
  //   if (!pageData?.validZipcode) {
  //     const defaultZip = t("app.common.defaultZipcode", { ns: "app" });
  //     if (defaultZip) {
  //       dispatch(setZipcode(defaultZip));
  //       dispatch(setValidZipcode(true));
  //       setIsConfirm(true);
  //     }
  //   }

  //   // cleanup this component on unmount
  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  useEffect(() => {
    if (pageData?.validZipcode && pageData?.zipCode?.length === 5) {

      setIsConfirm(true);        
    } else if (pageData?.validZipcode === false) {
      setIsConfirm(false);
      setErrors({
        ...errors,
        ["zipCode"]: `${t("app.zipCodePopup.invalidZip", { ns: "app" })}`,
      });
    }
  }, [pageData?.zipCode, pageData?.validZipcode]);

  // useEffect(() => {
  //   confirmRef.current = isConfirm && !(errors.zipCode?.length > 0);
  // }, [isConfirm, errors]);

  // useEffect(() => {
  //   zipRef.current = pageData?.zipCode;
  //   dispatch(setValidZipcode(null));
  //   if (zipRef.current?.length === 5) {
  //     handleZipcode(pageData?.zipCode);
  //     dispatch(
  //       validateZipcode({
  //         zipcode: zipRef.current,
  //         isEmailEnable: isEmailEnable,
  //       })
  //     );
  //   } else {
  //     !hidZipCode && isValidZipCode(zipRef.current);
  //   }
  // }, [pageData?.zipCode]);

  useEffect(() => {

   !hidZipCode && isValidZipCode(zipCode);
  }, [zipCode]);

  useEffect(() => {
    if(typeof isValidDAASZipcode == "boolean" && props?.fromGridWall && zipCode != undefined && !props?.forDeviceCard)
    {
    SetIsValidDAASzip(isValidDAASZipcode); 
    if(isValidDAASZipcode)
      {
        props?.newCustomerBtnClicked();
        navigate(`/${props?.forVBCURL}`);                
      }
      else{        
          isValidZipCode("isInvalidDAASZip")          
      }
    }    
   }, [isValidDAASZipcode]);

   useEffect(() => {
    if(!!isZipcodeValidationSuccess && zipCode != undefined ){
      
        if(!!props?.forDeviceCard && !!props?.forByodCardURL?.length) {
          navigate(`/${props?.forByodCardURL}`); props?.closeBtnClick(false);
        }
        else if(!props?.fromGridWall && props?.vbcCardClicked )
          {
            navigate(`/${props?.forVBCURL}`);
          }           
         else{
           props?.newCustomerBtnClicked(zipCode)
        };
        if(props?.forDeviceCard) {props?.setForDeviceCard(false)};
    }
   }, [isZipcodeValidationSuccess]);


   
  const redirectDAASPage = ()=>
    {
      if(props?.fromGridWall)
        {
          navigate('/shop/products/devices/smartphones/verizonbusinesscomplete');
        }

    };

  const smartphoneLink =(
    <>
    {errors?.zipCode}
    <TextLink  
      size= "small"
    onClick={(e)=>{
      e.preventDefault();
      props.isVBC();   
      //props.newCustomerBtnClicked();   
      //navigate('shop/products/devices/smartphones')
    }}
    > Shop Smartphones </TextLink></>
  );
  
  
  const isValidZipCode = (zip) => {     
    
    if(zip !== undefined){
      
    const invalidZipCodes = t("zipCode.invalidZipcodes", {
      returnObjects: true,
    });
    let errorTexts = "";
    // dispatch(setZipcode(zip));
    errorTexts =
      !zip || !zip?.trim()
        ? `${t("app.addressCodePopup.zipRequired", { ns: "app" })}`
        : "";
    if (zip?.length < 5 && !(!zip || !zip?.trim())) {
      setIsConfirm(false);
      errorTexts = `${t("app.addressCodePopup.zipLength", { ns: "app" })}`;
    }  
    if(invalidZipCodes.includes(zip))
    {
      errorTexts = `${t("app.addressCodePopup.invalidZip", { ns: "app" })}`;
    }   
    if(zip === "isInvalidDAASZip")
      {
        errorTexts= `${t("app.addressCodePopup.nyZIPmessage", { ns: "app" })}`; 
        SetIsSmrtphclicked(true);
        SiteAnalytics.errorEncounter({title:errorTexts,subtitle:"", id: "", errorType: "VBC Zipcode" });
      }
      else
      {
        SetIsSmrtphclicked(false);
      } 
    if (zip?.length === 5) {
      if (!invalidZipCodes.includes(zip)) {
        setIsConfirm(true);
      } else {
        setIsConfirm(false);
        if (pageData.validZipcode === false) {
          errorTexts = `${t("app.addressCodePopup.invalidZip", { ns: "app" })}`;
        } else {
          if(props?.fromGridWall && !props?.forDeviceCard && !invalidZipCodes.includes(zip))
          {
          dispatch(
            validateZipcode({ zipcode: zip, isEmailEnable: isEmailEnable,isDaasZipCode:true})
          );
        }
        else
        {
          if(!invalidZipCodes.includes(zip))
          {
          dispatch(
            validateZipcode({ zipcode: zip, isEmailEnable: isEmailEnable})
          );
        }
        }
        }
      }
    }
    zipCode !== undefined && setErrors({ ...errors, ["zipCode"]: errorTexts });
  }
  };

  const onOpenedChange = (e) => {
    if (e === false) {
      // on modal close
      window.removeEventListener("keydown", handleKeyDown);
      window.history.back();
    }
  };
  

  // useEffect(() => {
  //   if (pageData?.isFios) {
  //     setContentObj(aemContent.loopQual.fios);
  //   } else {
  //     setContentObj(aemContent.loopQual.landing);
  //   }
  // }, [pageData?.isFios]);

  useEffect(()=>{
    const postalCode = lqPageData?.address?.place?.properties?.postalCode;
    if(postalCode){
      zipRef.current = postalCode;
      handleZipcode(lqPageData?.address?.place?.properties?.postalCode)
    }

  },[lqPageData?.address])

  const newCustomerBtnClicked = () => {
    if(!zipCode){
      const errorTexts = `${t("app.addressCodePopup.zipRequired", { ns: "app" })}`;
      setErrors({ ...errors, ["zipCode"]: errorTexts });
    }
    else{
      if(address){
        const  payload = {
          addressLine1:lqPageData?.address?.place?.properties?.street,
          city: lqPageData?.address?.place?.properties?.city,
          state: lqPageData?.address?.place?.properties?.state,
          zipCode: lqPageData?.address?.place?.properties?.postalCode,
          zipPlus4: lqPageData?.address?.place?.properties?.zipPlus4,
          unit: lqPageData?.unit?.unit
        }
        dispatch(callAddressValidation(payload));
        dispatch(validateZipcode({zipcode : zipCode, isZipFromGW : !!props?.forDeviceCard}));
        if(!!props?.forDeviceCard && !!props?.forByodCardURL?.length) {
          navigate(`/${props?.forByodCardURL}`);
          props?.closeBtnClick(false)
        }
      }else{
        if(props?.fromGridWall && !props?.forDeviceCard)
          {
            if(!(zipCode && zipCode.length <5 || errors.zipCode?.length >0))
              {              
                dispatch(validateZipcode({ zipcode: zipCode, isEmailEnable: isEmailEnable,isDaasZipCode:true}));   
              }      
          }
          else if(!(zipCode && zipCode.length <5 || errors.zipCode?.length >0))
          {   
            dispatch(validateZipcode({zipcode : zipCode, isZipFromGW : !!props?.forDeviceCard}));  
        // lqPageData?.flow === "4g" && props?.closeBtnClick(false)
          }
      }
      // props.newCustomerBtnClicked();
    }
    
  };

  useEffect(()=>{

    if(!props?.fromGridWall || (props?.fromGridWall && props?.forDeviceCard)){

    if( (globalPageData?.addressValidation?.serviceStatus?.success)) {

      if(lqPageData?.flow === "4g"){
        const req = {
          flow: lqPageData?.flow,
          street: lqPageData?.address?.place?.properties?.street,
          city: lqPageData?.address?.place?.properties?.city,
          state: lqPageData?.address?.place?.properties?.stateCode,
          zipCode: lqPageData?.address?.place?.properties?.postalCode,
          zipPlus4: lqPageData?.address?.place?.properties?.zipPlus4,
          eventCorrelationId: lqPageData?.fixedWirelessResponse?.eventCorrelationId,
          cband: lqPageData?.cband,
          mmw: lqPageData?.mmw,
          digitalQuote: !!unifiedCartParams?.quoteId,
          addressModal: true
        };
        dispatch(postLoopQualAddress(req));
        const  address = {
          addressLine1:lqPageData?.address?.place?.properties?.street,
          city: lqPageData?.address?.place?.properties?.city,
          state: lqPageData?.address?.place?.properties?.state,
          zipCode: lqPageData?.address?.place?.properties?.postalCode,
          zipPlus4: lqPageData?.address?.place?.properties?.zipPlus4,
          unit: lqPageData?.unit?.unit
        }    
        const payload = {
          planIds : landing4gPageData?.planDetails?.plans,
          address
        }
        dispatch(getTaxesCharges(payload))
       }
       props?.newCustomerBtnClicked();
       if(props?.forDeviceCard) {props?.setForDeviceCard(false)};

      // hidZipCode ? newCustomerPdpClicked() : newCustomerClicked();
      // onClose();
      // setHidZipCode(false)
    }
  }

  },[globalPageData?.addressValidation?.serviceStatus?.success])

  const existingCustomerBtnClicked = () => {
    props.existingCustomerBtnClicked();
  };

  // useEffect(()=>{
  //   return () => { 
  //     dispatch(setAddress(null));
  //     dispatch(setUnit(null));
  //     dispatch(setTotalAvailableUnit(null));
  //   };
  // },[])

  return (
    <Modal
      ariaLabel=""
      disableOutsideClick={true}
      hideCloseButton={true}
      {...isFrom4GLearn ? {closeButton : <></>} : {} }
      opened={props?.showNewCustomerModal || !isZipcode || hidZipCode}
      onOpenedChange={props?.closeBtnClick}
      disableFocusLock= {true}
     
    >
      <ModalTitle>
        {
          isFrom4GLearn ?  <TitleLockup
          data={{
            title: {
              bold: true,
              size: "titleLarge",
              children:  t("app.addressCodePopupLTEPage.heading", { ns: "app" }),
            },
          }}
        /> : 
        (props?.fromGridWall && props?.forDeviceCard) ? 
        <TitleLockup
        data={{
          title: {
            bold: true,
            size: "titleLarge",
            children:  t("app.addressCodePopupGridWallPage.headingOnDeviceClick", { ns: "app" }),
          },
        }}/> :     
       props?.fromGridWall ?
       <TitleLockup
       data={{
         title: {
           bold: true,
           size: "titleLarge",
           children:  t("app.addressCodePopupGridWallPage.heading", { ns: "app" }),
         },
       }}
      />       
       :
        <TitleLockup
          data={{
            title: {
              bold: true,
              size: "titleLarge",
              children:  t("app.addressCodePopup.heading", { ns: "app" }),
            },
          }}
        />

        }
       
      </ModalTitle>
      <ZipcodeModalBody>
        {isFrom4GLearn  || props?.forDeviceCard?  <Body size="medium">
          {t("app.addressCodePopupLTEPage.description", { ns: "app" })}
        </Body> :
         props?.fromGridWall ?
         <Body size="medium">
          {t("app.addressCodePopupGridWallPage.description", { ns: "app" })}
        </Body> 
         :
         <Body size="medium">
         {t("app.addressCodePopup.description", { ns: "app" })}
        </Body>
        }
        <MarginSpacerL />
       <Body size="medium">
                {t("app.addressCodePopup.requiredFieldDesc", { ns: "app" })}
        </Body>
        <MarginSpacerL />
        <MarginSpacerL />
        {props?.fromGridWall &&  !props?.forDeviceCard? <></>: <div>
          <MapQStreetAddress
            // errorMessage={contentObj.errors.address.required}
            required={hidZipCode}
            placeHolder=""
            label={isFrom4GLearn ? t("app.addressCodePopupLTEPage.inputAddressLabel", { ns: "app" }) : t("app.addressCodePopup.inputAddressLabel", { ns: "app" })}
            helperText=""
            onSelectionChange={(value) => {
              setNewAddress(value)
              dispatch(setAddress(value));
              setUnitsAvailable(-Infinity);
            }}
            handleAddressInput={() => {}}
            isAddressEmty={false}
            // isError={errorMessages.addressInfoErr}
            setAddressFieldError={(value) => {
              setErrorMessages({
                ...errorMessages,
                addressInfoErr: value,
              });
            }}/>
        </div>}
        {showAddress2 && (<ColWidth isUnitFieldAvailable={isUnitFieldAvailable}>
          <MapQUnit
          label="Apt, suite, or unit"
          locusID = {address?.place?.properties?.locusID}
          ntasAddrID={address?.place?.properties?.ntasAddrID}
          onSelectionChange={value => {
            setUnits(value);
            dispatch(setUnit(value));
          }}
          setTotalAvailableUnits={value => {
            if (address?.place?.properties) {
              setUnitsAvailable(Number(value));
            }
          }}
          // isError={errorMessages?.addressInfoErr}
          />
        </ColWidth>)}
       
        {!hideZipCode && <>
        <ColWidth>
          <Input
            label={t("app.addressCodePopup.inputLabel", { ns: "app" })}
            maxLength={5}
            name="zipcode"
            disabled={newAddress != undefined || newAddress != null }
            width={"100%"}
            value={zipCode}
            type="number"
            // onChange={(e) => isValidZipCode(e.target.value)}
            onChange={(e) => {
              let numberVal = (e?.target?.value)?.length > 5 ? (e?.target?.value).substring(0,5) : (e?.target?.value);
              isValidZipCode(numberVal);
              const zipVal = e?.target?.value.trim();
              if (!isNaN(zipVal) && zipVal?.length<=5 ){
                handleZipcode(zipVal);
              } else if(isNaN(zipVal)){
                handleZipcode("");
              }
            }
           }
           onKeyDown={(e) => {
            if (e?.key === "Enter") {
              const zipVal = e.target.value.trim();
              if (!isNaN(zipVal) && zipVal?.length == 5 && isConfirm) {
                newCustomerBtnClicked();
              }
            }
            }}
            error={errors?.zipCode?.length > 0 ?? false}
           // errorText={errors?.zipCode ?? ""}
           errorText={isSmartphonelink === true? smartphoneLink : errors?.zipCode ?? ""}
          />
        </ColWidth>
               {/* {isSmartphonelink === true && <>{<span style={{fontSize:'smaller'}}>  {' '}  {smartphoneLink} </span>}</>} */}
      
        </>}
       
       
      </ZipcodeModalBody>
      <MarginSpacerXL/>
      <div
        children={
          <>
             <Button
             size="large"
             use="primary"
             width={isMobile && "100%"}
             disabled={false}
             data-track={`${t("app.addressCodePopupGridWallPage.heading", { ns: "app" })}:Continue`}
             onClick={() => newCustomerBtnClicked()}
          >
            Continue
          </Button>
          {!hideZipCode && !isfromAgentLinkPage && <>
            <MarginSpacerXL />
            <Login>
                <Body bold size="large">
                   Already a Verizon Business customer?    
                </Body>
                <Button 
                    use="secondary"
                    size="small"
                    onClick={() => {
                      existingCustomerBtnClicked();
                    }}
                    secondary={true}
                  >
                    Login
                </Button>
                
            </Login>
            </>}
          </>
        }
      
      >

      </div>
      {/* <ModalFooter
        children={
          <ButtonWrapper
            width={isMobile ? "100%" : "200px"}
            onClick={() => {
              newCustomerBtnClicked();
            }}
          >
            Continue
          
          </ButtonWrapper>
        }
      /> */}
     
      
    </Modal>
  );
};
const Login = styled.div`
display:flex;
margin-bottom: 6px;
flex-direction: row;
align-items: center;
column-gap: 15px;
justify-content: flex-start;
@media screen and (max-width: 725px) {
  display:flex;
  flex-direction: column;
  row-gap: 15px;
  align-items: flex-start;
}
`
const ColWidth = styled.div`
width:100%;
padding-top:24px;
display : ${props => props.isUnitFieldAvailable};
`


export default NewCustomerAddressModal;
